import axios from "axios";
import qs from "qs";
import { Alert } from "apower-ui";
import Vue from "vue";
import ReplyForm from "./ReplyForm.vue";
import CommentList from "./CommentList.vue";
import commentService from "./commentService.js";

const comment = {
  data() {
    return {
      authorActive: false,
      emailActive: false,
      commentActive: false,
      btnLoading: false,
      showAlert: false,
      showCancelBtn: false,
      pageIndex: 0,
      prePageNum: 5,
      totalPageCount: 0,
      pageLoading: false,
      commentPostID: 0,
    };
  },

  mounted() {
    this.initPaging();
    this.initValue();
    this.initArticleRating();
    // this.initForm()
  },

  methods: {
    initPaging() {
      let pagingDiv = null;
      if (document.getElementsByClassName("paging").length) {
        pagingDiv = document.getElementsByClassName("paging")[0];
      } else {
        return;
      }
      this.pageIndex = 0;
      this.totalPageCount = pagingDiv.dataset.pageCount;
      const liArr = pagingDiv.getElementsByTagName("li");
      let liItem;
      let value;
      for (let i = 0; i < liArr.length; i++) {
        liItem = liArr[i];
        value = liItem.textContent;
        if (liItem.className == "active") {
          this.pageIndex = value - 1;
        }
      }
    },
    initValue: function () {
      if (this.$refs.nameInput && this.$refs.nameInput.value === "Anonymous") {
        this.$refs.nameInput.value = "";
      }

      if (
        this.$refs.emailInput &&
        this.$refs.emailInput.value === "anonymous@apowersoft.com"
      ) {
        this.$refs.emailInput.value = "";
      }
      if (this.$refs.commentInput) {
        this.$refs.commentInput.value = "";
      }
      if (this.$refs.leaveCommentPostId) {
        this.commentPostID = this.$refs.leaveCommentPostId.value;
      }
    },

    doLeaveCommentSubmit(e) {
      if (this.btnLoading) {
        return;
      }
      if (e.preventDefalut) {
        e.preventDefalut();
      }

      // input 添加 doLeaveCommentSubmit
      const rootDiv = e.target.parentElement.parentElement;
      const inputArr = rootDiv.getElementsByTagName("input");
      let inputEl;
      for (let i = 0; i < inputArr.length; i++) {
        inputEl = inputArr[i];
        inputEl.className = "touched";
      }
      inputEl = rootDiv.getElementsByTagName("textarea")[0];
      inputEl.className = "touched";

      const emailReg = /^\w+@+[0-9a-zA-Z]+\.(com|com.cn|edu|hk|cn|net)$/;
      const emailValue = this.$refs.emailInput.value;
      if (
        this.$refs.nameInput.value != "" &&
        this.$refs.commentInput.value &&
        emailValue &&
        emailReg.test(emailValue)
      ) {
        this.doSubmit();
      }
    },

    doSubmit() {
      this.btnLoading = true;
      const url = "/wp" + this.$refs.leaveCommentForm.getAttribute("action");

      const data = {
        author: this.$refs.nameInput.value,
        email: this.$refs.emailInput.value,
        comment: this.$refs.commentInput.value,
        comment_post_ID: this.$refs.leaveCommentPostId.value,
        comment_parent: this.$refs.leaveCommentParentId.value,
        url: location.host,
      };

      commentService
        .submitComment(url, data)
        .then(() => {
          this.btnLoading = false;
          console.log(222);
        })
        .catch((e) => {
          console.log(222333);
          if (e.response && e.response.status == 409) {
            const str = e.response.data.message.replace(
              /^\s*<p>(.+?)<\/p>\s*$/,
              "$1"
            );
            this.alert(str);
          }
          this.btnLoading = false;
        });
    },
    onInputLeaveComment(e) {
      console.log(e.target);
      if (e.target.value) {
        e.target.className = "touched";
      } else {
        e.target.className = "";
      }
    },
    onInputEmail(e) {
      console.log(e);
      if (e.target.value) {
        e.target.className = "touched";
      } else {
        e.target.className = "";
      }
    },
    alert(str, offset) {
      this.$message({
        message: str,
        type: "warning",
        offset: offset || 100,
      });
    },
    onCommentLike(e) {
      const div = e.target.parentElement.parentElement;
      const id = div.dataset.id;
      const post = commentService.like(id, 1);
      const rect = div.getBoundingClientRect() || {};
      const offset = rect.top || 100;
      if (!post) {
        return;
      }
      post
        .then((res) => {
          const data = res.data;
          if (data.code == -1) {
            this.alert(data.message, offset);
          } else if (data.code == 1) {
            // 成功 num +1
            this.alert(data.message, offset);
          }
        })
        .catch((e) => {
          console.log(333, e);
        });
    },
    onCommentDislike(e) {
      const div = e.target.parentElement.parentElement;
      const id = div.dataset.id;
      const post = commentService.like(id, -1);
      const rect = div.getBoundingClientRect() || {};
      const offset = rect.top || 100;
      if (!post) {
        return;
      }
      post
        .then((res) => {
          const data = res.data;
          if (data.code == -1) {
            this.alert(data.message, offset);
          } else if (data.code == 1) {
            // 成功 num +1
            this.alert(data.message, offset);
          }
        })
        .catch((e) => {
          console.log(333, e);
        });
    },
    onCommentReply(e) {
      const div = e.target.parentElement.parentElement;
      const id = div.dataset.id;
      // let post = this.like(id,-1);
      const repl = this.createRelp({
        commentPostID: this.$refs.leaveCommentPostId.value,
        commentParent: id,
      });
      div.appendChild(repl.$el);
    },
    createAr(props) {
      // 手动创建
      const Constructor = Vue.extend(Alert);
      const comp = new Constructor({
        propsData: props,
      });
      comp.$mount();
      return comp;
    },
    createRelp(props) {
      const Constructor = Vue.extend(ReplyForm);
      const comp = new Constructor({
        propsData: props,
      });
      comp.$mount();
      return comp;
    },
    createCommentList(props) {
      const Constructor = Vue.extend(CommentList);
      const comp = new Constructor({
        propsData: props,
      });
      comp.$mount();
      return comp;
    },
    prevPage() {
      if (this.pageIndex == 0) {
        return;
      }
      this.gotoPage(this.pageIndex - 1);
    },
    nextPage() {
      if (this.pageIndex == this.pageCount - 1) {
        return;
      }
      this.gotoPage(this.pageIndex + 1);
    },
    gotoPage(n) {
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      const postID = this.$refs.leaveCommentPostId.value;
      const post = {
        post_id: postID,
        action: "wc_load_more_comments",
        offset: n * this.prePageNum,
        per_page: this.prePageNum,
      };
      const url = "/wp/wp-admin/admin-ajax.php?nocache=1";
      axios
        .post(url, qs.stringify(post), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          if (res.data && res.data.comments) {
            this.pageLoading = false;
            this.showList(res.data);
            this.freshPaging(n);
          }
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    freshPaging(page) {
      let pagingDiv = null;
      if (document.getElementsByClassName("paging").length) {
        pagingDiv = document.getElementsByClassName("paging")[0];
      } else {
        return;
      }
      const liArr = pagingDiv.getElementsByTagName("li");
      const preItem = pagingDiv.getElementsByClassName("prev")[0];
      const nextItem = pagingDiv.getElementsByClassName("next")[0];
      let liItem;
      let value;
      let lastActive;
      let currentPage;
      for (let i = 0; i < liArr.length; i++) {
        liItem = liArr[i];
        value = liItem.textContent;
        if (liItem.className == "active") {
          lastActive = liItem;
        }
        if (value == page + 1) {
          currentPage = liItem;
        }
      }
      lastActive.className = "";
      currentPage.className = "active";
      this.pageIndex = page;
      if (this.pageIndex == 0) {
        preItem.setAttribute("disabled", "disabled");
      } else {
        preItem.removeAttribute("disabled");
      }
      // debugger
      if (this.pageIndex == this.totalPageCount - 1) {
        nextItem.setAttribute("disabled", "disabled");
      } else {
        nextItem.removeAttribute("disabled");
      }
    },
    showList(data) {
      const list = data.comments;
      const commentList = this.createCommentList({
        comments: list,
        postid: this.commentPostID,
      });
      const rootDiv = document.getElementById("comment-list");
      if (!rootDiv) {
        return;
      }
      rootDiv.innerHTML = "";
      rootDiv.appendChild(commentList.$el);
    },
    onInput(e) {
      console.log(e);
      // this.inputs.$on('input', function (e) {
      //   if (e.target.value) {
      //     $(e.target).addClass('touched')
      //   }
      //   else {
      //     $(e.target).removeClass('touched')
      //   }
      // })
    },
    initArticleRating() {
      let el = document.querySelector(".rating-share-section .rating");
      if (!el) {
        return;
      }
      window.aa = el;
      let ref = {
        starWrap: ".rating-stars",
        backgroundEl: ".background",
        currentEl: ".current",
        textEl: ".rating-text",
        valueEl: '[itemprop="ratingValue"]',
        countEl: '[itemprop="ratingCount"]',
        thanksEl: ".rating-thanks",
      };
      let _this = {};
      window._aa = _this;
      for (let item in ref) {
        _this[item] = el.querySelector(ref[item]);
      }
      for (let item in el.dataset) {
        _this[item] = el.dataset[item];
      }
      _this.selectable = true;
      let div = document.createElement("div");
      // return;
      _this.starWrap.append(div);
      div.outerHTML = `<div class="background">
      <i></i><i></i><i></i><i></i><i></i>
    </div>
    <div class="current">
      <i class="active"></i><i class="active"></i><i class="active"></i><i class="active"></i><i class="active"></i>
    </div>`;
      var startEls = Array.from(_this.starWrap.querySelectorAll("i"));
      var backgroundEls = Array.from(
        _this.starWrap.querySelectorAll(".background i")
      );
      var currentEls = Array.from(
        _this.starWrap.querySelectorAll(".current i")
      );
      let startItem;
      for (let i = 0; i < startEls.length; i++) {
        startItem = startEls[i];
        startItem.addEventListener("mouseenter", onMouseEnter);
        startItem.addEventListener("click", onClickStar);
      }
      function onMouseEnter(e) {
        let item = e.target;
        let index;
        if (backgroundEls.indexOf(item) !== -1) {
          index = backgroundEls.indexOf(item);
        } else if (currentEls.indexOf(item) !== -1) {
          index = currentEls.indexOf(item);
        }
        for (let i = 0; i < backgroundEls.length; i++) {
          if (i <= index && backgroundEls[i].className != "active") {
            backgroundEls[i].className = "active";
          } else if (i > index && backgroundEls[i].className != "") {
            backgroundEls[i].className = "";
          }
        }
        showLable(index);
      }
      function onClickStar(e) {
        if (!_this.selectable) {
          return;
        }
        _this.selectable = false;
        let item = e.target;
        let index;
        if (backgroundEls.indexOf(item) !== -1) {
          index = backgroundEls.indexOf(item);
        } else if (currentEls.indexOf(item) !== -1) {
          index = currentEls.indexOf(item);
        }
        showLable(index);
        sendValue(index + 1);
      }
      function showLable(index) {
        var ratingLables = el.dataset["ratingLabels"].split(";");
        _this.textEl.innerText = ratingLables[index];
      }
      function showThanksEl() {
        if (_this.thanksEl.className.indexOf("active") == -1) {
          _this.thanksEl.className = _this.thanksEl.className + " active";
        }
      }
      function disabledEl() {
        el.setAttribute("disabled", "disabled");
      }
      function sendValue(rating) {
        const data = {
          rating: rating,
        };
        axios
          .post(_this.posturl, qs.stringify(data), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.state == 1) {
              showThanksEl();
            }
            disabledEl();
          })
          .catch((e) => {
            console.log(e);
            disabledEl();
          });
      }
    },
  },
};

export default comment;
